
import Vue from "vue";
import axios from "axios";
import { hideNonProfessorStaffLists } from "@/config/staffDisplay";
import ProgressiveImage from "@/components/ProgressiveImage.vue";
import { prefetchStaffPhotoThumbs } from "@/utils/staffPhoto";

export default Vue.extend({
  components: { ProgressiveImage },
  props: ["post"],
  data: () => ({
    students: [] as any,
  }),
  mounted() {
    this.getStudentList();
  },
  methods: {
    getStudentList() {
      if (hideNonProfessorStaffLists) {
        this.students = [];
        return;
      }
      axios
        .post(Vue.prototype.apiUrl("get-item-list-all"), {
          collection: "graduated",
          need: {},
        })
        .then(async (response) => {
          this.students = response.data;
          this.students.sort((a: any, b: any) => parseInt(a.grade) < parseInt(b.grade) ? -1 : 1);
          await prefetchStaffPhotoThumbs(this.students);
        });
    },
  },
});
